import { Helpers } from '../../helpers';
import { IDivision } from '../../interfaces/idivision';
import { AssetTeam } from '../asset-team';
import { ForecastHorizontalDetail } from '../forecast-horizontal-detail';
import { ForecastVerticalDetail } from '../forecast-vertical-detail';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';
import { TeamDevelopmentArea } from '../team-development-area';

export class DivisionBase {
  DivisionId: number;
  Description: string;
  SortOrder: number | null;
  DivisionCode: string | null;
  AssetTeamId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontalDetails_Division?: Array<ForecastHorizontalDetail> | null;
  ForecastVerticalDetails_Division?: Array<ForecastVerticalDetail> | null;
  Projects_Division?: Array<Project> | null;
  ProjectTemplates_Division?: Array<ProjectTemplate> | null;
  TeamDevelopmentAreas_Division?: Array<TeamDevelopmentArea> | null;
  AssetTeam?: AssetTeam;

  constructor(item?: IDivision) {
    if (item) {

      this.DivisionId = item.DivisionId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.DivisionCode = item.DivisionCode;
      this.AssetTeamId = item.AssetTeamId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontalDetails_Division = Helpers.createClassArray(ForecastHorizontalDetail, item.ForecastHorizontalDetails_Division);
      this.ForecastVerticalDetails_Division = Helpers.createClassArray(ForecastVerticalDetail, item.ForecastVerticalDetails_Division);
      this.Projects_Division = Helpers.createClassArray(Project, item.Projects_Division);
      this.ProjectTemplates_Division = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_Division);
      this.TeamDevelopmentAreas_Division = Helpers.createClassArray(TeamDevelopmentArea, item.TeamDevelopmentAreas_Division);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}